import React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import __ from "src/utils/Translations";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import Settings from "src/Pages/Company/TotalReward/Settings/form";

export default () => {
  const companyName = useCompanyName();
  const companyId = useCompanyId();

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      <PageTitle
        heading={`${__(
          "Zarządzanie ustawieniami modułu dla firmy"
        )} ${companyName} (ID: ${companyId})`}
        breadcrumbsHeading={__("Ustawienia modułu")}
        pushToHistory
        breadcrumbs={[
          {
            title: "Total Reward Statement",
            link: `/ahr/total-reward`,
          },
        ]}
      />
      <Settings />
    </CSSTransitionGroup>
  );
};
